export const PASSWORD_HELP = 'Use 12–128 characters with uppercase and lowercase letters, a number and a symbol. Avoid common passwords and your username.';
export const passwordPolicyError = (password, username = '') => {
  if (typeof password !== 'string' || password.length < 12 || password.length > 128) return 'Password must contain 12 to 128 characters.';
  if (!/[A-Z]/.test(password) || !/[a-z]/.test(password) || !/[0-9]/.test(password) || !/[^A-Za-z0-9\s]/.test(password)) return 'Password must include uppercase and lowercase letters, a number and a symbol.';
  const simple = password.toLowerCase().replace(/[^a-z0-9]/g, '');
  if (/^(password|welcome|qwerty|letmein|administrator|admin|changeme|iloveyou|rcsdms|abcdefgh|123456)/.test(simple)) return 'Choose a less predictable password; common passwords are not allowed.';
  const account = String(username).split('@')[0].toLowerCase();
  if (account.length >= 4 && password.toLowerCase().includes(account)) return 'Password must not contain your username.';
  return '';
};
export const validatePasswordPayload = (payload, pathname, method) => {
  if (/\/login\/?$/.test(pathname) || !/\/user(?:\/|$)/.test(pathname) || !payload || typeof payload !== 'object') return;
  const check = (value, key = '', username = '') => {
    if (/^(password|new|newPassword|new_password)$/.test(key)) {
      if (value === '' && key === 'password' && /^(PUT|PATCH)$/i.test(method) && !/\/password\//.test(pathname)) return;
      const error = passwordPolicyError(value, username);
      if (error) throw new Error(error);
      return;
    }
    if (value && typeof value === 'object') Object.entries(value).forEach(([name, item]) => check(item, name, value.username || username));
  };
  check(payload);
  if (/\/password\/change\/?$/.test(pathname) && payload.new === payload.old) throw new Error('Choose a password different from your current password.');
};
